var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-navbar-nav',{staticClass:"ml-auto top-menu"},[(_vm.hasNotifications)?_c('b-nav-item',{attrs:{"to":{name:'userNotifications'}}},[_c('div',{staticClass:"notification"},[_vm._v("View User Notifications")])]):_vm._e(),_c('b-nav-item',{attrs:{"to":"/admin"}},[_vm._v("Home")]),_c('b-nav-item',{attrs:{"to":"/admin/help"}},[_vm._v("Help")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }